import { Chip } from '@material-ui/core';

import { useRtArrivesOrWaitingTime } from './useRtArrivesOrWaitingTime';

import makeClasses from './RtArrivesOrWaitingTime.styles';

export function RtArrivesOrWaitingTime(props: Props) {
  const { orderId, hasTurboUrgency, statusLabel } = props;

  const { theTime, rtStatus } = useRtArrivesOrWaitingTime({ orderId });

  const style = makeClasses({ rtStatus, hasTurboUrgency });

  if (isNaN(theTime) && !statusLabel) return null;

  const renderLabel = () => (
    <div className={style.container}>
      {statusLabel && (
        <span style={{ fontWeight: 'normal' }}>{statusLabel}</span>
      )}
      {!isNaN(theTime) && <>&nbsp;{theTime} min</>}
    </div>
  );

  return (
    <Chip
      label={renderLabel()}
      classes={{ root: style.chip, label: style.label }}
    />
  );
}

interface Props {
  orderId: number;
  hasTurboUrgency: boolean;
  statusLabel?: string;
}

// Origin logic to show -> rtWaitingSince using showCounter and zoneId
// previous at Revamped iconography and RT actions [RA-806]
// into DeliveryMethodLabel component
